import { links } from "@roman/shared/links";
import { useEffect } from "react";

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.location.href = links.privacyPolicy;
  }, []);
  return (
    <div className="w-full min-h-screen bg-white">
      別ページに移行しました。
      <a href={links.privacyPolicy} className="text-secondary underline">
        こちら
      </a>
      からご確認ください。
    </div>
  );
};
